import { FacebookPixel } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchFacebookPixels = async (adAccountId: string): Promise<FacebookPixel[]> =>
    privateApiWithRouteLeavingCancelation.get<FacebookPixel[]>(`facebook/graph/ad-accounts/${adAccountId}/pixels`);

export const CancelableFacebookPixelGateway = {
    cancelableFetchFacebookPixels,
};
